import request from '../api/request'

// 分页查询考试
export function queryExamList(param) {
  return request({
    url: '/exam/list',
    method: 'get',
    params: param
  })
}

// 新增考试
export function addExam(data) {
    return request({
      url: '/exam/add',
      method: 'post',
      data: data
    })
}

// 查询考试考生信息
export function queryExamAndUsers(examId) {
    return request({
      url: '/exam/queryExamAndUsers/' + examId,
      method: 'get',

    })
}

// 修改考试
export function modifyExam(data) {
    return request({
        url: '/exam',
        method: 'put',
        data: data
    })
}

//根据考试ID分页查询学生考试成绩
export function queryExamResByExamId(param) {
    return request({
        url: '/result/queryExamResByExamId/' + param.examId,
        method: 'get',
        params: param
    })
}

//根据考试ID查询考试和试卷信息
export function queryExamAndPaper(param) {
    return request({
        url: '/exam/queryExamAndPaper',
        method: 'get',
        params: param
    })
}

//考试答题回顾
export function reviewExam(param) {
    return request({
        url: '/result/reviewExam',
        method: 'get',
        params:param
    })
}

//查看错题信息
export function queryIncorrectAnswers(param) {
    return request({
        url: '/result/queryIncorrectAnswers',
        method: 'get',
        params:param
    })
}


//阅卷评分
export function correctSubjectiveScore(data) {
    return request({
        url: '/result/CorrectSubjectiveScore',
        method: 'post',
        data:data
    })
}

//根据学生ID分页查询所有考试信息
export function queryExamRes(param) {
    return request({
        url: '/result/queryExamRes',
        method: 'get',
        params:param
    })
}

//导出考生成绩
export function exportResult(param) {
    return request({
        url: '/result/export',
        method: 'get',
        params:param
    })
}


//按次序及小组导出考生成绩
export function exportResultGroup(examId) {
    return request({
        url: '/result/exportGroup/'+examId,
        method: 'get',
    })
}

// 删除考试
export function deleteExames(examIds) {
    return request({
      url: '/exam/'+ examIds,
      method: 'delete',
    })
}